import React from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { Link, useLocation, Routes, Route, Navigate } from 'react-router-dom';
import './QCManagement.css';
import MyQCView from './MyQCView';
import QCReports from './QCReports';
import TestCases from './TestCases/TestCases';
import TestCaseDetail from './TestCases/TestCaseDetail';
import TestSuites from './TestSuites/TestSuites';
import TestExecution from './TestExecution/TestExecution';
import Releases from './Releases/Releases';

const QCManagement = () => {
    const location = useLocation();
    const currentPath = location.pathname;

    // Check if we're viewing a detail page
    const isTestCaseDetail = currentPath.includes('/qc/test-cases/');
    const isExecutionDetail = currentPath.includes('/qc/test-execution/');

    return (
        <Container fluid className="qc-management-page">
            <Row className="mb-4">
                <Col lg={4}>
                    <h1 className="display-1">QC Management</h1>
                    <div className="display-2">Quality Control & Testing Management</div>
                </Col>
                <Col lg={8}>
                    <div className="text-end">
                        <Nav className="c-nav-tabs">
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/qc/overview"
                                    active={currentPath === '/qc/overview'}
                                >
                                    Overview
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/qc/test-execution"
                                    active={currentPath === '/qc/test-execution' || isExecutionDetail}
                                >
                                    Test Execution
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/qc/test-cases"
                                    active={currentPath === '/qc/test-cases' || isTestCaseDetail}
                                >
                                    Test Cases
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/qc/test-suites"
                                    active={currentPath === '/qc/test-suites'}
                                >
                                    Test Suites
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/qc/releases"
                                    active={currentPath === '/qc/releases'}
                                >
                                    Releases
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/qc/reports"
                                    active={currentPath === '/qc/reports'}
                                >
                                    Reports & Summary
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Routes>
                        <Route path="/" element={<Navigate to="/qc/overview" replace />} />
                        <Route path="/overview" element={<MyQCView />} />
                        <Route path="/test-execution" element={<TestExecution />} />
                        <Route path="/test-execution/:id" element={<TestExecution />} />
                        <Route path="/test-cases" element={<TestCases />} />
                        <Route path="/test-cases/:id" element={<TestCaseDetail />} />
                        <Route path="/test-suites" element={<TestSuites />} />
                        <Route path="/releases" element={<Releases />} />
                        <Route path="/reports" element={<QCReports />} />
                    </Routes>
                </Col>
            </Row>
        </Container>
    );
};

export default QCManagement;
